import styled from 'styled-components';

import { PortalButton, fonts, mixins } from '@custom-components';

export const StyledCard = styled.div`
  ${({ theme }) => `background-color: ${theme.lighterText}`};
  font-family: ${fonts.fontRegular};
  padding: 0 ${mixins.pxToRem(25)};
`;

export const LargeButton = styled(PortalButton)`
  margin: 0 auto ${mixins.pxToRem(20)};
  width: 100%;
  max-width: ${mixins.pxToRem(250)};
  font-size: ${mixins.pxToRem(16)};
  padding: ${mixins.pxToRem(10)} ${mixins.pxToRem(20)};
`;
